import { useSessionWarning } from '@/hooks/useSessionWarning'
import { useInactivityTimeout } from '@/hooks/useInactivityTimeout'

/**
 * Session management component that monitors:
 * 1. JWT token expiration - warns 5 minutes before token expires
 * 2. User inactivity - logs out after 2 hours of no activity
 *
 * Renders nothing visible, only manages session state.
 */
export function SessionWarning() {
  // Token expiry warning
  useSessionWarning()

  // Inactivity timeout
  useInactivityTimeout()

  return null
}
